import { fetchPost } from '../Service/ApiService'

export const bulkSendUploadPaymentProof = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`uploadpaymentproof/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};









